import { Component, OnInit, NgZone, Output,EventEmitter, AfterViewInit,ViewChild } from '@angular/core';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import { LeftAsideService } from '../left-aside.service';
import { LeftThoughRightService } from '../left-though-right.service';
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { SwUpdate } from '@angular/service-worker';
import { AppDataServiceService } from 'src/app/app-data-service.service';
import { any } from '@amcharts/amcharts4/.internal/core/utils/Array';
//import { Observable } from 'rxjs';


@Component({
  selector: 'app-left-though-right',
  templateUrl: './left-though-right.component.html',
  styleUrls: ['./left-though-right.component.css']
})
export class LeftThoughRightComponent implements  AfterViewInit  {
public selected_category_data;
title = "Title"
sub_title = '';
 

constructor(
  private swUpdate:SwUpdate,
  private zone: NgZone,
   public _getAllDataOfCat:LeftThoughRightService,
   private categoryData:LeftAsideService,
   private setDate:AppDataServiceService
   ) { 

    this.categoryData.componentMethodCalled$.subscribe(
      (data) => {
      this.sub_title = '';
      this.generateEnergyAllGroupCharts(data);
      }
    );
   }

 @Output()
  closeDetailsEnergy:EventEmitter<boolean> =  new EventEmitter<boolean>(); 
  showThisYear ="barMonthlyThisConsumption";
    ngOnInit() {
      this.categoryData.currentMessage.subscribe(message => this.selected_category_data = message)
     
    }
  ngAfterViewInit() {}

  

  drillDown(data){
    if(data.type == 'monthly'){
      if(this.sub_title  != ''){
        this.drillDeviceDaily(data);
      }
      else{
        this.drillDaily(data);
      }
     
    }
    else if(data.type == 'daily'){
      if(this.sub_title  != ''){
        this.drillDeviceHourly(data);
      }
      else{
        this.drillHourly(data);
      }
     
    }
    else if(data.type == 'device'){
      this.sub_title  = ' [ '+data.name+' ] '
      this.drillDevice(data);
      
    }
  }


  drillDaily(data){
    return this._getAllDataOfCat.getDailyEnergy(data).subscribe(
      data=> this.genrateEnergyGraph_4(data['data'].linechart),
      error=>console.error(error)
    );
  }

  drillHourly(data){
    return this._getAllDataOfCat.getHourlyEnergy(data).subscribe(
      data=> this.genrateEnergyGraph_3(data['data'].linechart),
      error=>console.error(error)
    );
  }
  drillDevice(data){
    return this._getAllDataOfCat.getDeviceEnergyAllChartData(data).subscribe(
      data=> this.setDataForAllEnergyCharts(data),
      error=>console.error(error)
    );
  }

  drillDeviceDaily(data){
    return this._getAllDataOfCat.getDeviceDailyEnergy(data).subscribe(
      data=> this.genrateEnergyGraph_4(data['data'].linechart),
      error=>console.error(error)
    );
  }

  drillDeviceHourly(data){
    return this._getAllDataOfCat.getDeviceHourlyEnergy(data).subscribe(
      data=> this.genrateEnergyGraph_3(data['data'].linechart),
      error=>console.error(error)
    );
  }

  




  genrateEnergyGraph_1(data){
            let title_text = `Energy Consumption  For date :  ${data[0].date} `;
            console.log('genrateEnergyGraph_1',data)
            console.log('genrateEnergyGraph_1',title_text)
            let name  = 'abcd';
            let thisObj = this;
            let chart = am4core.create("pieEnergyConsumption", am4charts.PieChart);
            let title = chart.titles.create();
            title.text = title_text;
            title.fontSize = 14;
            title.marginBottom = 10;

            chart.data = data
             var pieSeries = chart.series.push(new am4charts.PieSeries());
            pieSeries.dataFields.value = "energy";
            pieSeries.dataFields.category = "name";
            pieSeries.labels.template.disabled = true;
            pieSeries.slices.template.cornerRadius = 5;
            pieSeries.slices.template.innerCornerRadius = 3;
            pieSeries.slices.template.events.on("hit", function(ev) {
              console.log("clicked on ", ev.target.dataItem.dataContext);
              let data = ev.target.dataItem.dataContext;
              thisObj.drillDown(data)
             
             }, this);
            
            pieSeries.ticks.template.disabled = true;

            chart.legend = new am4charts.Legend();
            chart.legend.position = "right";
            chart.legend.fontSize = 10;
            let markerTemplate = chart.legend.markers.template;
            markerTemplate.width = 10;
            markerTemplate.height = 10;
            
            chart.innerRadius = am4core.percent(50);
            chart.radius = am4core.percent(70);

            var label = pieSeries.createChild(am4core.Label);
            label.text = "{values.value.sum}";
            label.horizontalCenter = "middle";
            label.verticalCenter = "middle";
            label.fontSize = 14;
            chart.legend.itemContainers.template.paddingTop = 0

            chart.legend.itemContainers.template.paddingBottom = 2
            chart.legend.itemContainers.template.paddingRight = 2
            //categoryAxis.renderer.labels.template.paddingBottom = 0



  }
      
  genrateEnergyGraph_2(data){
    console.log('genrateEnergyGraph_2',data)
    let thisObj = this;
      let chart = am4core.create("barMonthlyThisConsumption", am4charts.XYChart);

      let title = chart.titles.create();
      title.text = `Monthly Energy Consumption  For Year : ${data[0].year} `;
      title.fontSize = 14;
      title.marginBottom = 10;

      chart.data = null;
      chart.data = data;
      let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "month";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 30;
      categoryAxis.renderer.labels.template.horizontalCenter = "right";
      categoryAxis.renderer.labels.template.verticalCenter = "middle";
      categoryAxis.renderer.labels.template.rotation = -40;
      categoryAxis.tooltip.disabled = true;
      categoryAxis.renderer.fontSize = 10;

      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.renderer.minWidth = 50;
      valueAxis.fontSize = 10;

      // Create series
      let series = chart.series.push(new am4charts.ColumnSeries());
      series.sequencedInterpolation = true;
      series.dataFields.valueY = "energy";
      series.dataFields.categoryX = "month";
      series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
      series.columns.template.strokeWidth = 0;
      series.columns.template.events.on("hit", function(ev) {
        console.log("clicked on ", ev.target.dataItem.dataContext);
        let data = ev.target.dataItem.dataContext;
              thisObj.drillDown(data)
        }, this);
      series.tooltip.pointerOrientation = "vertical";
      series.columns.template.column.cornerRadiusTopLeft = 10;
      series.columns.template.column.cornerRadiusTopRight = 10;
      series.columns.template.column.fillOpacity = 0.8;
   

      // on hover, make corner radiuses bigger
      let hoverState = series.columns.template.column.states.create("hover");
      hoverState.properties.cornerRadiusTopLeft = 0;
      hoverState.properties.cornerRadiusTopRight = 0;
      hoverState.properties.fillOpacity = 1;

      series.columns.template.adapter.add("fill", function(fill, target) {
        return chart.colors.getIndex(target.dataItem.index);
      });
      chart.cursor = new am4charts.XYCursor();
  }   


  genrateEnergyGraph_3(data){
    console.log('genrateEnergyGraph_3',data)
    let thisObj = this;
      let chart = am4core.create("lineChartHrConsumption", am4charts.XYChart);

      let title = chart.titles.create();
      title.text = `Hourly Energy Consumption  For date : ${data[0].date} `;
      title.fontSize = 14;
      title.marginBottom = 10;

      //chart.paddingRight = 20;
      console.log('hourly data' , data)
      chart.data = data;
      /*let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
      dateAxis.baseInterval = {
        "timeUnit": "hour",
        "count": 1
      };*/
    //  dateAxis.tooltipDateFormat = "HH:mm:ss 'o''clock'";
    let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "hour";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.fontSize = 10;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        //categoryAxis.renderer.labels.template.rotation = 90;
        categoryAxis.tooltip.disabled = true;
        //categoryAxis.renderer.minHeight = 110;
      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.fontSize = 10;

      let series = chart.series.push(new am4charts.LineSeries());
      series.dataFields.categoryX = "hour";
      series.dataFields.valueY = "energy";
      series.tooltipText = "Energy: [bold]{valueY}[/]";
      //series.fillOpacity = 0.3;
      series.stroke = am4core.color("red")
      series.strokeWidth = 2;
      series.fillOpacity = 1;
      series.fill = am4core.color("red");
      series.fontSize = 10

      var fillModifier = new am4core.LinearGradientModifier();
      fillModifier.opacities = [1, 0];
      fillModifier.offsets = [0, 1];
      fillModifier.gradient.rotation = 90;
      series.segments.template.fillModifier = fillModifier;

      series.tensionX = 0.7;


      chart.cursor = new am4charts.XYCursor();
      chart.cursor.lineY.opacity = 0;      
        /*
        chart.events.on("datavalidated", function () {
            dateAxis.zoom({start:0.8, end:1});
          });*/
  }      

  genrateEnergyGraph_4(data){
    console.log('genrateEnergyGraph_4',data)
    let thisObj = this;
    console.log('daily data', data)
      let chart = am4core.create("barDailyConsumptionMonthly", am4charts.XYChart);

      let title = chart.titles.create();
      title.text = `Daily Energy Consumption For Month : ${data[0].month }`;
      title.fontSize = 14;
      title.marginBottom = 10;

      chart.data = data;
      var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
      dateAxis.dateFormatter.dateFormat = "dd-mm-yyyy";
      dateAxis.fontSize = 10;

      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.fontSize = 10;
        // Create series
      let series = chart.series.push(new am4charts.ColumnSeries());
      series.dataFields.valueY = "energy";
      series.dataFields.dateX = "date";
      series.dateFormatter.dateFormat = "yyyy-MM-dd";
        series.name = "date";
      series.columns.template.tooltipText = "{dateX}: [bold]{valueY}[/]";
      series.columns.template.fillOpacity = .8;
      series.fontSize = 10;
      series.columns.template.events.on("hit", function(ev) {
        console.log("clicked on ", ev.target.dataItem.dataContext);
        let data = ev.target.dataItem.dataContext;
              thisObj.drillDown(data)
        }, this);

      let columnTemplate = series.columns.template;
      columnTemplate.strokeWidth = 2;
      columnTemplate.strokeOpacity = 1;

      chart.cursor = new am4charts.XYCursor();
          
  }

  closeEnergy(){
  this.closeDetailsEnergy.emit(true);
  }
  showYearGraph(){
    // this.getLRBarGraph();
  }

  setDataForAllEnergyCharts(data){
    this.genrateEnergyGraph_1(data.data.hourly.data.pichart) ; 
    this.genrateEnergyGraph_2(data.data.monthly.data.linechart);
    this.genrateEnergyGraph_3(data.data.hourly.data.linechart) ; 
    this.genrateEnergyGraph_4(data.data.daily.data.linechart) ;  
  }


  /*
  generateEnergyAllGroupCharts(left_Aside){
      this.title = left_Aside.lable
      //this.categoryData.currentMessage.subscribe(message => this.selected_category_data = message)
      return this._getAllDataOfCat.getDataAfterClick(left_Aside).subscribe(
      data=> this.setDataForAllCharts(data),
      error=>console.error(error)
    );
  }*/

  generateEnergyAllGroupCharts(data){
    let date;
    console.log('generateEnergyAllGroupCharts',data)
    this.setDate.getdate.subscribe(dates => date = dates)
    if(data.type == 'energy'){
        this.title = data.data.lable
        //this.categoryData.currentMessage.subscribe(message => this.selected_category_data = message)
        return this._getAllDataOfCat.getEnergyAllChartData(data.data,date).subscribe(
        data=> this.setDataForAllEnergyCharts(data),
        error=>console.error(error)
      );
    }
  }  
}

/*this.categoryData.callComponentMethod(
    {
        data:left_Aside,
        type:'energy'
    }); 
  */
